<template>
    <b-modal
      v-if="currentCharger != null"
      :visible="visible"
      @hidden="hide"       
      @change="change"
      scrollable
      ref="modal_line_details"
      id="modal-line-details"
      no-close-on-backdrop      
      :title="$t('charger.title')"
      :ok-only="true" 
      :ok-title="$t('close')" 
    >
        <!-- scheda descrittiva in alto -->
    <!-- | foto | Product | id | -->
    <b-row>
      <b-col cols="4" sm="4">
        <img v-if="currentCharger.product_image" class="ml-4" :src="pathDeviceImages + currentCharger.product_image"
          style="height:80px; width:auto; float: left; margin-right: 10px" />
        <img v-else :src="pathDeviceImages + '17230.jpg'" style="height:auto; width:80px;" />
      </b-col>
      <b-col cols="8" offset="1" offset-sm="0" sm="6">
        <b-row>
          <b-col>
            {{ $t("charger.prod_desc") }}
            <div><strong>CHARGER</strong></div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            {{ $t("charger.vers") }}
            <div><strong>{{currentCharger.version}}</strong>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
<!-- Stato -->
    <b-row>
        <b-col cols="12" offset-sm="1" sm="10"><strong>{{$t("charger.state")}}</strong>
        </b-col>
    </b-row>
    <b-row>
        <b-col cols="6" offset="1">{{$t("charger.abilitato")}}</b-col>
        <b-col cols="5" :style="{'color': (currentCharger.enabled == 'ON') ? 'green':'black' }">{{currentCharger.enabled}}</b-col>
    </b-row>
    <b-row>
        <b-col cols="6" offset="1">{{$t("charger.calibrazione")}}</b-col>
        <b-col cols="5" :style="{'color': (currentCharger.calibrated == 'ON') ? 'green':'black' }">{{currentCharger.calibrated}}</b-col>
    </b-row>
    <b-row>
        <b-col cols="6" offset="1">{{$t("charger.compensazione")}}</b-col>
        <b-col cols="5" :style="{'color': (currentCharger.temperature_compensation == 'ON') ? 'green':'black' }">{{currentCharger.temperature_compensation}}</b-col>
    </b-row>
    <hr>

<!-- Errors found -->
    <b-row >
        <b-col cols="12" offset-sm="1" sm="10"><strong>{{$t("details_cu_modal.cu_error")}}</strong>
        </b-col>
    </b-row>
    <b-row v-if='currentCharger.errore_comunicazione=="ON"'>
        <b-col cols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("charger.e_com")}}
        </b-col>
    </b-row>
    <b-row v-if='currentCharger.errore_hardware=="ON"'>
        <b-col cols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("charger.e_hw")}}
        </b-col>
    </b-row>
    <b-row v-if='currentCharger.errore_sovrastemperatura=="ON"'>
        <b-col cols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("charger.e_stemp")}}
        </b-col>
    </b-row>
    <b-row v-if="NessunErrore(currentCharger)">
        <b-col cols="12" offset-sm="1"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("charger.no_error")}}
        </b-col>
    </b-row>
    <hr>      

    <!-- Details -->
    <b-row>
        <b-col cols="12" offset-sm="1" sm="10"><strong>{{ $t("details_lamp.lamp_details") }}</strong>
        </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" offset="1">{{ $t("details_lamp.lamp_code") }}</b-col>
      <b-col cols="5" >{{currentCharger.product_code}}</b-col>
    </b-row>
    <b-row>
      <b-col cols="6" offset="1">{{ $t("details_lamp.lamp_order_code") }}</b-col>
      <b-col cols="5" >{{currentCharger.order_code}}</b-col>
    </b-row>
   

  </b-modal>
</template>

<script>
// import Vue from 'vue'

export default {
  name: "ChargerDetails",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    currentCharger: null,
    scanning: false,
    visible: {
      type: Boolean,
      default: false
    },
  },

  emits:['hide', 'change'],

  data() {
    return {
        pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
        pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF,                       //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
        isVisible: false, //*
    };
  },

  computed: {
  },

  created() {
  },
  mounted() {
  },

  methods: {
 
    //cerca nelle properties dell'oggetto disp, isola quelle che contengono 'error' e verifica se il valore è ON
    NessunErrore(disp) {
        let noerrore = true
        for (const property in disp)
        {
            if ((property.includes("err")) && (disp[property] === "ON"))
            {
                noerrore = false;
            }
        }
        return noerrore;     
    },

    //si attiva con l'evento 'change' ed emette verso il padre un evento 'change'
    change(visible) {
        // console.log("MASSI01: change visible", visible)
        this.$emit("change", visible);
    },
    //si attiva con l'evento 'hide' ed emette verso il padre un evento 'hide'
    hide() {
        // console.log("MASSI02: emesso hide")
         this.$emit("hide");
    },

  }
}
</script>

<style>
</style>